import React, { useEffect, useState } from 'react'

const STEP_MS = 30_000

/**
 * Wall-clock sync with authenticator TOTP periods (30s).
 * Does not display the code — only remaining time in the current period.
 */
export default function MfaTotpCodeHint({ className = '' }) {
  const [msLeft, setMsLeft] = useState(() => STEP_MS - (Date.now() % STEP_MS))

  useEffect(() => {
    const tick = () => setMsLeft(STEP_MS - (Date.now() % STEP_MS))
    tick()
    const id = setInterval(tick, 200)
    return () => clearInterval(id)
  }, [])

  const secondsLeft = Math.max(1, Math.ceil(msLeft / 1000))
  const progress = msLeft / STEP_MS
  const urgent = secondsLeft <= 5
  const r = 10
  const c = 2 * Math.PI * r
  const dash = c * progress

  return (
    <div className={`flex items-start gap-2.5 ${className}`}>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        className="shrink-0 mt-0.5"
        aria-hidden="true"
      >
        <circle cx="14" cy="14" r={r} fill="none" stroke="#E5E7EB" strokeWidth="2.5" />
        <circle
          cx="14"
          cy="14"
          r={r}
          fill="none"
          stroke={urgent ? '#DC2626' : '#0A5169'}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          transform="rotate(-90 14 14)"
          style={{ transition: 'stroke-dasharray 0.15s linear' }}
        />
        <text
          x="14"
          y="14"
          textAnchor="middle"
          dominantBaseline="central"
          className="text-[9px] font-semibold"
          fill={urgent ? '#DC2626' : '#374151'}
          style={{ fontSize: 9, fontWeight: 600 }}
        >
          {secondsLeft}
        </text>
      </svg>
      <p className={`text-xs leading-snug ${urgent ? 'text-red-600' : 'text-gray-500'}`}>
        Codes refresh every 30 seconds — enter the code currently shown in your app
        {urgent ? ' (refreshing soon)' : ''}.
      </p>
    </div>
  )
}
